/* Magnifying.com.au — Redesign 2026 interactions */
(function(){
'use strict';

// ── Mobile drawer ──────────────────────────────────────────
function initDrawer(){
  var ham = document.getElementById('js-ham');
  var overlay = document.getElementById('js-mob-overlay');
  var drawer = document.getElementById('js-mob-drawer');
  var closeBtn = document.getElementById('js-mob-close');
  if(!ham || !drawer) return;
  function open(){ overlay.classList.add('open'); drawer.classList.add('open'); document.body.style.overflow='hidden'; }
  function shut(){ overlay.classList.remove('open'); drawer.classList.remove('open'); document.body.style.overflow=''; }
  ham.addEventListener('click', open);
  if(closeBtn) closeBtn.addEventListener('click', shut);
  if(overlay) overlay.addEventListener('click', shut);
  drawer.querySelectorAll('.mob-item button').forEach(function(btn){
    btn.addEventListener('click', function(){ btn.closest('.mob-item').classList.toggle('open'); });
  });
}

// ── Reviews carousel ───────────────────────────────────────
function initCarousel(root){
  var track = root.querySelector('.car-track');
  var prev = root.querySelector('.car-prev');
  var next = root.querySelector('.car-next');
  var dotsEl = root.querySelector('.car-dots');
  if(!track) return;
  var cards = track.children.length;
  function perPage(){ var w = window.innerWidth; if(w < 768) return 1; if(w < 1024) return 2; return 4; }
  var page = 0;
  var pp = perPage();
  var pages = Math.ceil(cards / pp);

  function rebuildDots(){
    dotsEl.innerHTML = '';
    for(var i=0;i<pages;i++){
      var d = document.createElement('button');
      d.className = 'car-dot' + (i===page?' active':'');
      d.setAttribute('aria-label','Page '+(i+1));
      (function(idx){ d.onclick = function(){ goTo(idx); }; })(i);
      dotsEl.appendChild(d);
    }
  }
  function goTo(p){
    page = Math.max(0, Math.min(pages-1, p));
    var wrap = track.parentElement;
    var tx = -page * (wrap.clientWidth + 16);
    track.style.transform = 'translateX(' + tx + 'px)';
    if(prev) prev.disabled = page === 0;
    if(next) next.disabled = page === pages - 1;
    dotsEl.querySelectorAll('.car-dot').forEach(function(d,i){ d.classList.toggle('active', i===page); });
  }
  function onResize(){
    var newPP = perPage();
    if(newPP !== pp){
      pp = newPP;
      pages = Math.ceil(cards / pp);
      page = 0;
      rebuildDots();
      goTo(0);
    } else {
      goTo(page);
    }
  }
  rebuildDots();
  if(prev) prev.onclick = function(){ goTo(page-1); };
  if(next) next.onclick = function(){ goTo(page+1); };
  goTo(0);
  window.addEventListener('resize', onResize);

  var startX = 0;
  track.addEventListener('touchstart', function(e){ startX = e.touches[0].clientX; }, {passive:true});
  track.addEventListener('touchend', function(e){
    var dx = e.changedTouches[0].clientX - startX;
    if(Math.abs(dx) > 40) goTo(dx < 0 ? page+1 : page-1);
  });
}

// ── PDP gallery ────────────────────────────────────────────
function initGallery(){
  var main = document.getElementById('rd-main-img');
  var zoomOverlay = document.getElementById('rd-zoom');
  var zoomImg = document.getElementById('rd-zoom-img');
  if(!main) return;
  document.querySelectorAll('.thumb').forEach(function(thumb){
    thumb.addEventListener('click', function(){
      var src = thumb.getAttribute('data-full');
      if(src){
        main.src = src;
        document.querySelectorAll('.thumb').forEach(function(t){ t.classList.remove('active'); });
        thumb.classList.add('active');
      }
    });
  });
  var galleryMain = document.querySelector('.gallery-main');
  if(galleryMain && zoomOverlay && zoomImg){
    galleryMain.addEventListener('click', function(){
      zoomImg.src = main.src;
      zoomOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
    zoomOverlay.addEventListener('click', function(){
      zoomOverlay.classList.remove('open');
      document.body.style.overflow = '';
    });
  }
}

// ── PDP tabs ───────────────────────────────────────────────
function initTabs(){
  var tabs = document.querySelectorAll('.tab-btn');
  if(!tabs.length) return;
  function openTab(name){
    tabs.forEach(function(b){
      var match = b.getAttribute('data-tab') === name;
      b.classList.toggle('active', match);
      b.setAttribute('aria-selected', match);
    });
    document.querySelectorAll('.tab-panel').forEach(function(p){
      p.classList.toggle('active', p.getAttribute('data-panel') === name);
    });
  }
  tabs.forEach(function(b){
    b.addEventListener('click', function(){ openTab(b.getAttribute('data-tab')); });
  });
  document.querySelectorAll('[data-open-tab]').forEach(function(link){
    link.addEventListener('click', function(e){
      var name = link.getAttribute('data-open-tab');
      openTab(name);
      var panel = document.querySelector('[data-panel="'+name+'"]');
      if(panel){ e.preventDefault(); panel.scrollIntoView({behavior:'smooth', block:'start'}); }
    });
  });
}

// ── Sticky ATC ────────────────────────────────────────────
function initStickyAtc(){
  var pdpTop = document.getElementById('rd-pdp-top');
  var sticky = document.getElementById('rd-sticky-atc');
  if(!pdpTop || !sticky) return;
  var obs = new IntersectionObserver(function(entries){
    var e = entries[0];
    sticky.classList.toggle('show', !e.isIntersecting);
  }, {threshold:0, rootMargin:'0px 0px -100px 0px'});
  obs.observe(pdpTop);
}

// ── PDP quantity ──────────────────────────────────────────
function initQty(){
  document.querySelectorAll('.qty').forEach(function(grp){
    var input = grp.querySelector('.qty-input');
    if(!input) return;
    var minus = grp.querySelector('[data-qty-minus]');
    var plus = grp.querySelector('[data-qty-plus]');
    if(minus) minus.addEventListener('click', function(){
      var v = Math.max(1, (parseInt(input.value,10)||1) - 1);
      input.value = v;
      input.dispatchEvent(new Event('change'));
    });
    if(plus) plus.addEventListener('click', function(){
      var v = (parseInt(input.value,10)||1) + 1;
      input.value = v;
      input.dispatchEvent(new Event('change'));
    });
  });
}

// ── Variant selector → updates form ID + price ────────────
function initVariants(){
  var sel = document.querySelector('[data-variant-select]');
  if(!sel) return;
  var data = window.RD_VARIANTS;
  if(!data) return;
  var idInput = document.querySelector('[name="id"][data-variant-id]');
  var priceEl = document.querySelector('[data-price-now]');
  var wasEl = document.querySelector('[data-price-was]');
  var stockEl = document.querySelector('[data-stock]');
  var atc = document.querySelector('[data-atc]');
  function fmt(cents){ return window.Shopify && Shopify.formatMoney ? Shopify.formatMoney(cents, window.RD_MONEY || '${{amount}}') : ('$' + (cents/100).toFixed(2)); }
  function update(){
    var v = data[sel.value];
    if(!v) return;
    if(idInput) idInput.value = v.id;
    if(priceEl) priceEl.textContent = fmt(v.price);
    if(wasEl){
      if(v.compare_at_price && v.compare_at_price > v.price){
        wasEl.textContent = fmt(v.compare_at_price);
        wasEl.style.display = '';
      } else {
        wasEl.style.display = 'none';
      }
    }
    if(stockEl){
      stockEl.className = v.on_backorder ? 'stock-backorder' : (v.available ? 'stock-in' : 'stock-out');
      stockEl.textContent = v.on_backorder ? 'Available on Backorder' : (v.available ? 'In Stock, ships within 1 to 2 business days' : 'Sold out');
    }
    if(atc){
      atc.disabled = !v.available;
      atc.textContent = v.available ? 'Add to Cart' : 'Sold out';
    }
  }
  sel.addEventListener('change', update);
  update();
}

// ── Collection: filter accordion + SEO toggle ─────────────
function initCollection(){
  document.querySelectorAll('.filter-title').forEach(function(btn){
    btn.addEventListener('click', function(){
      var open = btn.classList.toggle('open');
      var list = btn.nextElementSibling;
      if(list) list.style.display = open ? '' : 'none';
    });
  });
  var sideBtn = document.querySelector('[data-open-filters]');
  var sidebar = document.getElementById('rd-sidebar');
  var ovr = document.getElementById('rd-sidebar-ovr');
  function openSide(){ if(sidebar){ sidebar.classList.add('open'); } if(ovr){ ovr.style.display='block'; } document.body.style.overflow='hidden'; }
  function shutSide(){ if(sidebar){ sidebar.classList.remove('open'); } if(ovr){ ovr.style.display='none'; } document.body.style.overflow=''; }
  if(sideBtn) sideBtn.addEventListener('click', openSide);
  if(ovr) ovr.addEventListener('click', shutSide);
  var sideClose = document.getElementById('rd-sidebar-close');
  if(sideClose) sideClose.addEventListener('click', shutSide);

  var seoBtn = document.getElementById('rd-seo-toggle');
  var seoContent = document.getElementById('rd-seo-content');
  if(seoBtn && seoContent){
    seoBtn.addEventListener('click', function(){
      var exp = seoBtn.getAttribute('aria-expanded') === 'true';
      seoBtn.setAttribute('aria-expanded', !exp);
      seoContent.classList.toggle('open', !exp);
    });
  }
  var explainerClose = document.querySelector('[data-explainer-close]');
  if(explainerClose) explainerClose.addEventListener('click', function(){
    var p = explainerClose.closest('.explainer');
    if(p) p.style.display = 'none';
  });

  var sort = document.getElementById('rd-sort');
  if(sort){
    sort.addEventListener('change', function(){
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      window.location.href = url.toString();
    });
  }
}

// ── AJAX ATC (uses Shopify Ajax API; falls back to form submit) ──
function initAjaxAtc(){
  var form = document.querySelector('form[data-product-form]');
  if(!form) return;
  form.addEventListener('submit', function(e){
    if(!window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('.atc-btn');
    var orig = btn ? btn.textContent : '';
    if(btn){ btn.disabled = true; btn.textContent = 'Adding…'; }
    var fd = new FormData(form);
    fetch('/cart/add.js', {method:'POST', body:fd, headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(){
        if(btn){ btn.textContent = 'Added ✓'; btn.style.background = 'var(--green)'; btn.style.color = '#fff'; }
        return fetch('/cart.js').then(function(r){ return r.json(); });
      })
      .then(function(cart){
        document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = cart.item_count; });
        setTimeout(function(){ if(btn){ btn.disabled=false; btn.textContent = orig; btn.style.background=''; btn.style.color=''; } }, 1800);
      })
      .catch(function(){
        if(btn){ btn.disabled=false; btn.textContent = orig; }
        form.submit();
      });
  });
}

// ── Init ──────────────────────────────────────────────────
function init(){
  initDrawer();
  document.querySelectorAll('.carousel-wrap').forEach(initCarousel);
  initGallery();
  initTabs();
  initStickyAtc();
  initQty();
  initVariants();
  initCollection();
  initAjaxAtc();
}
if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
})();
